import custom from '../custom';

export default {
  line: {
    borderColor: custom.grayMedium
  }
};
